<template>
  <div class="extras-step">
    <div class="component-title mem-font--checkout-view__section-title">
      {{ $t("extras") }}
    </div>

    <div class="foundation-section" v-if="showFoundation">
      <div
        v-html="spartanFoundationQuestion.moreInfoContents"
        class="question-body"
      ></div>
      <div class="question-answers">
        <div
          class="question-answer"
          :class="{
            'is-selected': spartanFoundationQuestionAnswer.id === answer.id,
          }"
          v-for="(answer, index) in spartanFoundationQuestion.questionAnswers"
          :key="index"
          @click="setFoundationAnswer(answer)"
        >
          <div>{{ answer.answer }}</div>
        </div>
      </div>
    </div>

    <div class="charity-section" v-if="showCharity">
      <div class="section-subtitle">{{ $t("checkout_charity_title") }}</div>
      <fundraising-companies-section
        :descriptionTextKey="fundraisingDescription"
        :privacyPolicyTextKey="'givestar_policy_text'"
        :companiesList="fundraisingCompanies"
        :amountList="fundraisingAmountList"
        :isNoFundraisingSelected="isNoFundraisingSelected"
        :errors="errors"
        @on-company-change="onFundraisingCompanyChange"
        @on-amount-change="errors.fundraisingAmount = false"
      />
    </div>

    <div v-if="hasRefundProtectSlot" class="widget-divider"></div>
    <slot name="refundProtect" />
  </div>
</template>

<script>
import { isEmpty, toNumber } from "lodash";
import { mapGetters, mapMutations } from "vuex";
import { appLinksParams } from "@/common/mixins";

export default {
  components: {
    "fundraising-companies-section": () =>
      import("./components/FundraisingCompaniesSection.vue"),
  },
  mixins: [appLinksParams],
  data: () => ({
    isNoFundraisingSelected: false,
    errors: {
      fundraisingCompany: false,
      // not used (for now)
      fundraisingAmount: false,
    },
  }),
  props: {
    submitExtras: Boolean,
    paymentMethodsRemountKey: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters([
      "checkoutRegion",
      "spartanFoundationQuestion",
      "spartanFoundationQuestionAnswer",
      "checkoutFundraisingCompany",
      "checkoutParams",
      "checkoutFundraisingCompanies",
      "hasCheckoutCharities",
    ]),
    fundraisingCompanies() {
      return this.checkoutFundraisingCompanies;
    },
    showFoundation() {
      // if (this.checkoutRegion !== "US") return;
      return !isEmpty(this.spartanFoundationQuestion);
    },

    fundraisingCompanyIsValid() {
      // const fundraisingRequiredRegions = ["EU", "GB", "US"];
      // if (!fundraisingRequiredRegions.includes(this.checkoutRegion))
      //   return true;
      if (!this.showCharity) return true;
      if (!isEmpty(this.checkoutFundraisingCompany)) return true;

      return this.isNoFundraisingSelected;
    },
    fundraisingAmountList() {
      return []
    },
    showCharity() {
      if (!this.checkoutParams.show_givestar) return;
      return this.hasCheckoutCharities;
    },
    // TODO: need to come up with a different implementation.
    fundraisingDescription() {
      if (this.checkoutRegion === "US") return "us_givestar_description";
      if (this.checkoutRegion === "GB") return "givestar_description";
      if (this.checkoutRegion === "EU") return "givestar_description";
      return "";
    },
    hasRefundProtectSlot() {
      return !!this.$slots.refundProtect;
    },
  },
  watch: {
    submitExtras: {
      handler(val) {
        if (!val) return;
        // Givestar fundraising company is required
        if (!this.fundraisingCompanyIsValid) {
          this.$set(this.errors, "fundraisingCompany", true);
          return;
        }
        //
        if (isEmpty(this.checkoutFundraisingCompany))
          return this.$emit("change-step");
        // No need to validate
        if (isEmpty(this.fundraisingAmountList))
          return this.$emit("change-step");
        // Amount item is not selected
        if (!this.checkoutFundraisingCompany.total) {
          this.$set(this.errors, "fundraisingAmount", true);
          return;
        }
        return this.$emit("change-step");
      },
    },
  },
  methods: {
    ...mapMutations(["setSpartanFoundationQuestionAnswer"]),
    setFoundationAnswer(answer) {
      let answerAmount = toNumber(answer.addOnAmount);
      let previousAnswerAmount = toNumber(
        this.spartanFoundationQuestionAnswer.addOnAmount || 0
      );

      if (this.spartanFoundationQuestionAnswer.id === answer.id) return;
      if (answerAmount === 0 && previousAnswerAmount === 0) {
        this.setSpartanFoundationQuestionAnswer(answer);
        return;
      }

      this.setSpartanFoundationQuestionAnswer(answer);
      this.$emit("on-details-change");
    },
    onFundraisingCompanyChange(noFundraising) {
      this.$set(this.errors, "fundraisingCompany", false);
      this.isNoFundraisingSelected = noFundraising;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
$mobile-view: 1024px;
$mobile-padding: 24px;
.charity-dialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 52px;
  padding-bottom: 48px;
  color: #000000;
  background-color: #ffffff;
  .dialog-section {
    max-width: 304px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 24px;
    img {
    }
    .section-title {
      margin-top: 16px;
      margin-bottom: 10px;
      text-align: center;
      font-size: 18px;
      font-weight: 700;
      line-height: 21px; /* 116.667% */
    }
    .section-text {
      text-align: center;
      font-size: 15px;
      font-weight: 500;
      line-height: 22px; /* 146.667% */
    }
  }
  .dialog-button {
    margin-top: 16px;
  }
}
.extras-step {
  padding-bottom: 130px;
  @media screen and (max-width: $mobile-view) {
    background-color: #ffffff;
    padding-top: 40px;
    padding-bottom: 24px;
  }
  .component-title {
    margin-bottom: 52px;
    @media screen and (max-width: $mobile-view) {
      display: none;
    }
  }
  .section-subtitle {
    font-size: 18px;
    font-weight: 700;
    line-height: 21px;

    margin-bottom: 22px;
  }
  .section-text {
    font-size: 16px;
    font-weight: 500;
    line-height: 133.4%; /* 21.344px */
    @media screen and (max-width: $mobile-view) {
      font-size: 14px;
      line-height: 20px;
    }
  }
  .section-subline {
    font-size: 12px;
    line-height: 16px;
  }
  .widget-divider {
    &::after {
      content: " ";
      display: flex;
      height: 1px;
      background-color: #e2e2e2;
      margin-top: 40px;
      margin-bottom: 40px;
    }
  }
  .foundation-section {
    &::after {
      content: " ";
      display: flex;
      height: 1px;
      background-color: #e2e2e2;
      margin-top: 40px;
      margin-bottom: 40px;
    }
    @media screen and (max-width: $mobile-view) {
      padding-left: 24px;
      padding-right: 24px;
    }
    .question-body {
    }
    .question-answers {
      margin-top: 22px;
      display: grid;
      grid-template-columns: repeat(auto-fill, 120px);
      gap: 8px;
      @media screen and (max-width: $mobile-view) {
        margin-top: 30px;
        grid-template-columns: 1fr 1fr;
      }
      .question-answer {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 13px;
        font-weight: 700;
        line-height: normal;
        text-transform: uppercase;
        text-align: center;
        height: 74px;
        border-radius: 12px;
        border: 1px solid #d8d8d8;
        @include cursorPointer;
        &.is-selected {
          border: 1px solid #cf1019;
        }
        @media screen and (max-width: $mobile-view) {
          height: 80px;
        }
      }
    }
  }
  .charity-section {
    @media screen and (max-width: $mobile-view) {
      // padding-bottom: 24px;
      padding-left: 24px;
      padding-right: 24px;
    }

    .charities-list {
      display: grid;
      grid-template-columns: repeat(auto-fill, 154px);
      gap: 8px;
      margin-top: 22px;
      margin-bottom: 22px;
      @media screen and (max-width: $mobile-view) {
        grid-template-columns: 1fr 1fr;
        margin-top: 30px;
        margin-bottom: 26px;
      }
      .charities-list-item {
        position: relative;
        height: 100px;
        @media screen and (max-width: $mobile-view) {
          height: 80px;
        }
        border-radius: 12px;
        border: 1px solid #d8d8d8;
        padding-left: 24px;
        padding-right: 24px;

        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        text-align: center;

        font-size: 12px;
        font-weight: 700;
        line-height: normal;
        text-transform: uppercase;

        @include cursorPointer;
        &.is-selected {
          border-color: #cf1019;
        }
        .company-image {
          transform: scale(0.2);
          position: absolute;
        }
      }
    }
    a {
      color: #4f4f4f;
    }
    .charity-description {
      .modal-link {
        margin-left: 4px;
        text-decoration: underline;
        @include cursorPointer;
        @media screen and (max-width: $mobile-view) {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
